// extracted by mini-css-extract-plugin
export default {"noData":"NoData_noData__ZChhS","noDataHeader":"NoData_noDataHeader__ZYnJb"};